<template>
  <div class="dashboard-base">
    <header-base pageType='dashboard'/>
    <dashboard-sessions-list/>
    <footer-base/>
  </div>
</template>

<script>
import DashboardSessionsList from '@/components/DashboardSessionsList'
import HeaderBase from '@/components/HeaderBase'
import FooterBase from '@/components/FooterBase'
export default {
  name: 'dashboard-base',
  data () {
    return {}
  },
  components: {
    DashboardSessionsList,
    HeaderBase,
    FooterBase
  }
}
</script>
